import { ActionType, createAction } from 'typesafe-actions';
import { OrganizationGroup } from '../../../types/organizationGroup';

export const fetchOrgGroupFulfilled = createAction(
  'FETCH_ORG_GROUP_FULFILLED',
  (payload: OrganizationGroup) => payload
)<OrganizationGroup>();

export type OrgGroupActions = ActionType<typeof fetchOrgGroupFulfilled>;
